module.exports = __webpack_public_path__ + "img/order_icon_selected.f49a055e.png";